import { apiClient } from "../../base/ApiClient";


// Customer Details
export const createCustomerDetails = async (postData) => {
  const response = await apiClient.post(`/client/customer-details/`, postData);
  return response.data;
};

export const getCustomerDetails = async (client_id) => {
  const response = await apiClient.get(`/client/customer-details/${client_id}/`);
  return response.data;
};
